import React, { useState } from 'react';
import DashboardLayout from '../components/layouts/DashboardLayout';
import SkillPracticeGrid from '../components/skill_practice/SkillPracticeGrid';

const LearningCornerHeader = ({ activeTab, onTabClick }) => {
    const tabs = [
        { key: 'vocabulary', label: 'Vocabulary', icon: 'style' },
        { key: 'grammar', label: 'Grammar', icon: 'edit_note' },
    ];

    const baseClasses = "flex items-center gap-2 pb-3 border-b-2 transition-all";
    const activeClasses = "text-primary-blue font-bold border-primary-blue";
    const inactiveClasses = "text-slate-500 dark:text-slate-400 font-medium hover:text-slate-800 dark:hover:text-slate-200 border-transparent";

    return (
        <header className="bg-background-light dark:bg-card-dark z-10 shrink-0 px-6 pt-8 pb-4 md:px-10">
            <div className="mx-auto max-w-6xl">
                <div className="flex flex-col gap-4 mb-8">
                    <div>
                        <h1 className="text-3xl font-black text-slate-900 dark:text-white tracking-tight md:text-4xl">
                            Góc Học Tập 📚
                        </h1>
                        <p className="mt-2 text-base text-slate-500 dark:text-slate-400 font-normal">
                            Luyện tập từ vựng và ngữ pháp để chinh phục kỳ thi Flyers.
                        </p>
                    </div>
                </div>
                {/* Tabs */}
                <div className="flex flex-wrap gap-8 border-b border-slate-200 dark:border-slate-800 -mb-px">
                    {tabs.map(tab => (
                        <button
                            key={tab.key}
                            onClick={() => onTabClick(tab.key)}
                            className={`${baseClasses} ${activeTab === tab.key ? activeClasses : inactiveClasses}`}
                        >
                            <span className="material-symbols-outlined text-[22px]">{tab.icon}</span>
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </header>
    );
};

const LearningCorner = () => {
    const [activeTab, setActiveTab] = useState('vocabulary');

    return (
        <DashboardLayout>
            <LearningCornerHeader activeTab={activeTab} onTabClick={setActiveTab} />
            <div className="flex-1 overflow-y-auto px-6 pb-10 md:px-10">
                <div className="mx-auto max-w-5xl">
                    {/* Both vocabulary and grammar tabs use SkillPracticeGrid as placeholder */}
                    <SkillPracticeGrid activeTab={activeTab} />
                </div>
            </div>
        </DashboardLayout>
    );
};

export default LearningCorner;
